import { render } from "./BusinessName.vue?vue&type=template&id=730c7013"
import script from "./BusinessName.vue?vue&type=script&lang=js"
export * from "./BusinessName.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__